import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import CarDeliveryTemplate from "../../sections/car-delivery-template";
import CarDatePicker from "../../react-components/car-date-picker";
import { checkoutProgressAction, setSessionIdAction, setProgressBarDataAction } from "../../redux/actions/actions";
import { selectShowCheckoutProgressBar } from "../../selectors/application";
import { formatProgressBarSteps } from "../../utils/progressBar";
import { useHistory } from "react-router-dom";

/**
 * There is no integrations made for this component
 * The disgn was changed and this is currently not used
 * You are probably looking for BookingCarDelivery
 */

const CarBookingDatetime = ({ fields, updateProgressBar, user, setProgressBarData }) => {
  const history = useHistory();
  const { ctaBooking } = fields;
  const { link, colorScheme, iconName } = ctaBooking.fields || {};
  const { href, text } = link?.value || {};
  const carDeliveryDatePickerDetails = {
    location: {
      bodyText: null
    }
  };
  const timeAndDateDetails = {
    heading: {
      // html: "<span>Time and date</span>",
      // type: "h4"
    },
    calendarProps: {
      okButton: {
        buttonText: "Ok",
        width: "auto",
        icon: null,
        isDisabled: false
      },
      cancelLink: { buttonText: "Cancel", externalLink: "#" },
      onDateSelect: data => console.log(data + "date selected"),
      showTime: true,
      onTimeSlotSelect: data => console.log(data),
      noSlotsText: "No available time slots",
      openToDate: { day: 8, month: 5, year: 2021 },
      disablePreviousDates: true,
      availableTimeSlots: [
        {
          date: { day: 8, month: 5, year: 2021 },
          timeSlots: [
            {
              startTime: "09:00",
              endTime: "11:00",
              label: "09:00 - 11:00",
              value: "09:00 - 11:00"
            },
            {
              startTime: "11:00",
              endTime: "13:00",
              label: "11:00 - 13:00",
              value: "11:00 - 13:00"
            },
            {
              startTime: "13:00",
              endTime: "15:00",
              label: "13:00 - 15:00",
              value: "13:00 - 15:00"
            }
          ]
        },
        {
          date: { day: 9, month: 5, year: 2021 },
          timeSlots: [
            {
              startTime: "14:00",
              endTime: "16:00",
              label: "14:00 - 16:00",
              value: "14:00 - 16:00"
            },
            {
              startTime: "16:00",
              endTime: "18:00",
              label: "16:00 - 18:00",
              value: "16:00 - 18:00"
            },
            {
              startTime: "18:00",
              endTime: "20:00",
              label: "18:00 - 20:00",
              value: "18:00 - 20:00"
            }
          ]
        },
        {
          date: { day: 10, month: 5, year: 2021 },
          timeSlots: [
            {
              startTime: "08:00",
              endTime: "10:00",
              label: "08:00 - 10:00",
              value: "08:00 - 10:00"
            },
            {
              startTime: "11:00",
              endTime: "13:00",
              label: "11:00 - 13:00",
              value: "11:00 - 13:00"
            }
          ]
        }
      ]
    },
    showCheckboxContainer: false,
    termsCheckbox: {
      label: "I agree to the <a class='label-link'>Test drive T&Cs</a>"
    },
    ageCheckbox: {
      label: "I am above 18 and have a driving licence"
    },
    testDriveSubmit: {
      buttonText: text,
      colorScheme,
      iconName,
      callback() {
        history.replace(href);
      }
    }
  };
  useEffect(() => {
    const { currentStep, _barSteps } = formatProgressBarSteps(fields?.template?.fields?.progressBar?.fields?.steps);
    setProgressBarData(_barSteps);
    updateProgressBar(currentStep + 1);
    return function cleanUp() {
      setProgressBarData(null);
      updateProgressBar(null);
    };
  }, []);
  return (
    <div className="car-delivery-date-wrapper">
      <CarDeliveryTemplate fields={fields}>
        <CarDatePicker fields={fields} {...carDeliveryDatePickerDetails} timeAndDateDetails={timeAndDateDetails} />
      </CarDeliveryTemplate>
    </div>
  );
};
const mapStateToProps = state => ({
  user: state.user,
  sessionId: state.sessionId,
  progressBarIndex: selectShowCheckoutProgressBar(state)
});
const mapDispatchToProps = dispatch => ({
  updateProgressBar: data => dispatch(checkoutProgressAction(data)),
  setSessionId: sessionId => dispatch(setSessionIdAction(sessionId)),
  setProgressBarData: data => dispatch(setProgressBarDataAction(data)),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(withSitecoreContext()(CarBookingDatetime));
